export default () => {
    let toggleMenuButtons    = document.querySelectorAll('.js-menu-toggle, .js-main-menu a');
    let submenus             = document.querySelectorAll('.site-nav .submenu');
    let toggleSubmenuButtons = document.querySelectorAll('.js-submenu-toggle, .js-submenu a');
    let _body                = document.body;
    let searchTrigger        = document.querySelectorAll('.js-trigger-search');
    let searchField          = document.getElementById('search-field');
    let windowHeight         = window.innerHeight;
    let new_scroll_position  = 0;
    let last_scroll_position;

    Array.prototype.forEach.call(toggleMenuButtons, function (item, index) {
        item.addEventListener('click', function () {
            if (_body.classList.contains('search-show')) {
                _body.classList.remove('search-show');
            } else {
                _body.classList.toggle('menu-show');

                submenus.forEach(function (item) {
                    item.classList.remove('active');
                });
            }
        });
    });

    Array.prototype.forEach.call(toggleSubmenuButtons, function (item, index) {
        item.addEventListener('click', function () {
            if (_body.classList.contains('search-show')) {
                _body.classList.remove('search-show');
            } else {
                _body.classList.toggle('submenu-show');
            }
        });
    });

    Array.prototype.forEach.call(searchTrigger, function (item, index) {
        item.addEventListener('click', (e) => {
            e.preventDefault();

            _body.classList.add('search-show');
            searchField.focus();
        })
    });

    if (window.pageYOffset >= 50) {
        _body.classList.add('fixed-nav', 'scrolled');
    }

    if (window.pageYOffset > (windowHeight - 125)) {
        _body.classList.add('fixed-subnav');
    }

    window.addEventListener('scroll', function () {
        last_scroll_position = window.pageYOffset;

        if (new_scroll_position < last_scroll_position && last_scroll_position > 80) {
            _body.classList.remove('slideDown');
            _body.classList.add('slideUp');
        } else if (new_scroll_position > last_scroll_position) {
            _body.classList.remove('slideUp');
            _body.classList.add('slideDown');
        }

        new_scroll_position = last_scroll_position;

        if (window.pageYOffset >= 50) {
            _body.classList.add('fixed-nav', 'scrolled');
        } else {
            _body.classList.remove('fixed-nav');
        }
    });
};